import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OperationalBreakdownItem, OperationalReport, SupervisorService } from '../../../core/services/supervisor.service';
import { restoreCsrTheme } from '../../csr/csr-theme';

@Component({
  selector: 'app-supervisor-operational-report',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './supervisor-operational-report.component.html',
  styleUrls: ['./supervisor-operational-report.component.scss'],
})
export class SupervisorOperationalReportComponent implements OnInit, OnDestroy {
  report: OperationalReport | null = null;
  fromDate = this.today();
  toDate = this.today();
  private readonly sub = new Subscription();
  private pollTimer?: ReturnType<typeof setInterval>;

  constructor(private readonly supervisor: SupervisorService) {}

  ngOnInit(): void {
    restoreCsrTheme();
    this.load();
    this.pollTimer = setInterval(() => this.load(), 30000);
    this.sub.add(this.supervisor.operationalReport$.subscribe(report => this.report = report));
  }

  ngOnDestroy(): void {
    if (this.pollTimer) clearInterval(this.pollTimer);
    this.sub.unsubscribe();
  }

  load(): void {
    this.supervisor.fetchOperationalReport(this.fromDate, this.toDate);
  }

  downloadCsv(): void {
    window.open(this.supervisor.reportExportUrl('operational', this.fromDate, this.toDate), '_blank');
  }

  fmtSecs(seconds?: number): string {
    if (!seconds || seconds < 0) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${String(secs).padStart(2, '0')}`;
  }

  top(items?: OperationalBreakdownItem[]): OperationalBreakdownItem[] {
    return (items ?? []).slice(0, 8);
  }

  private today(): string {
    return new Date().toISOString().slice(0, 10);
  }
}
